<template>
  <div>
    <RevTabs
      class="mb-32"
      :label="tabsLabel"
      role="tablist"
      scrollable
      variant="flexible"
    >
      <RevTabItem
        v-for="tab in tabs"
        :key="tab.key"
        :active="tab.isActive"
        :data-qa="tab.dataQa"
        :label="tab.label"
        role="tab"
        :to="tab.to"
      >
        <RevBadge
          v-if="tab.badgeCount && tab.badgeCount > 0"
          :count="tab.badgeCount"
        />
      </RevTabItem>
    </RevTabs>

    <slot />
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationNamedRaw } from 'vue-router'

import { RevBadge } from '@ds/components/Badge'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

export interface TabConfig {
  key: string
  label: string
  to: RouteLocationNamedRaw
  isActive: boolean
  dataQa?: string
  badgeCount?: number | undefined
}

export interface CareTabsContainerProps {
  tabs: TabConfig[]
  tabsLabel: string
}

defineProps<CareTabsContainerProps>()
</script>
